/**
 * Core-100 R4 — CORE-BR: "MUST NOT present a forecast as an observed condition."
 *
 * One label per stored reading kind (`weather_alerts.observation_kind`), used by the surfaces that
 * show a stored weather record (the assignment notice; the alert card's provenance block uses the same
 * three labels, pinned by test) so no surface can word a
 * forecast as an observation, an observation as a forecast, or guess the kind of a legacy row whose
 * kind was never recorded.
 */
export type StoredReadingKind = 'current_observation' | 'forecast' | null | undefined;

/** Short label for the reading kind. */
export function weatherReadingLabel(kind: StoredReadingKind): string {
  if (kind === 'forecast') return 'Forecast';
  if (kind === 'current_observation') return 'Observed condition';
  return 'Reading type not recorded';
}

